import React, { useState } from "react";
import rocket from "../Image/rocket.png";
import player from "../Image/player.png";
import bitcoin from "../Image/bitcoin.png";
function Gametable() {
  const [active, setActive] = useState("high");
  const [limit, setLimit] = useState(10);

  const data = Array(10).fill({
    name: "Crash",
    time: "09:21:01 AM",
    player: "User526490",
    amount: "22.4996975",
    multiplier: "x2.86",
    payout: "64.3491348",
  });

  return (
    <div className="hero-section">
      <div className="container top-bar">
        <div className="d-flex  table-range">
          <div className="togglebox">
            <div
              className={`tab ${active === "history" ? "active" : ""}`}
              onClick={() => setActive("history")}
            >
              History
            </div>

            <div
              className={`tab ${active === "high" ? "active" : ""}`}
              onClick={() => setActive("high")}
            >
              High Rollers
            </div>

            <div
              className={`tab ${active === "rare" ? "active" : ""}`}
              onClick={() => setActive("rare")}
            >
              Rare wins
            </div>
          </div>

          <div>
            <select
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
              className="limit-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
            </select>
          </div>
        </div>
        <div className="mt-2 table-responsive-wrapper">
          <table className="custom-table">
            <thead>
              <th className="text-start">Name</th>
              <th className="text-start">Time</th>
              <th className="text-start">Player</th>
              <th className="text-start">Amount</th>
              <th className="text-start">Multiplier</th>
              <th className="text-start">Payout</th>
            </thead>
            <tbody>
              {data.slice(0, limit).map((item, index) => (
                <tr>
                  <td className="text-start fw-semibold"style={{ color:"#4E7BCE" }}>
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={rocket} alt="logo" className="icon" />
                      {item.name}
                    </div>
                  </td>

                  <td className="text-start fw-semibold" style={{ color:"#4E7BCE" }}>{item.time}</td>

                  <td className="text-start fw-semibold">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={player} alt="" className="user-img" />
                      {item.player}
                    </div>
                  </td>

                  <td className="text-start fw-semibold">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={bitcoin} alt="" className="coin" />
                      {item.amount}
                    </div>
                  </td>

                  <td className="text-start">
                    <span className="custom-badge">{item.multiplier}</span>
                  </td>

                  <td className="text-start payout fw-semibold">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={bitcoin} alt="" className="coin" />
                      {item.payout}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Gametable;
